import { useMemo } from 'react'
import moment from 'moment/moment'

import { AutocompleteOption } from '@types'

export type FormFiltersType = {
  fromDay: string
  department: AutocompleteOption<string> | null
  qual: AutocompleteOption<string> | null
  position: AutocompleteOption<string> | null
  group: AutocompleteOption<string> | null
  showFormatDate: boolean
}

export const useDefaultValues = (): FormFiltersType => {
  return useMemo(
    () => ({
      fromDay: moment().startOf('day').toISOString(),
      department: null,
      qual: { id: 'ALL', label: 'ALL' },
      position: null,
      group: null,
      showFormatDate: false,
    }),
    []
  )
}
